import React, { useState, useEffect, useRef, useMemo, useCallback } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { useUserProfile } from '../contexts/UserProfileContext';
import { usePendingLeaves } from '../contexts/PendingLeavesContext';
import {
  FaHandshake, FaRegMoneyBillAlt, FaChartLine, FaShieldAlt, FaReceipt,
  FaUserTag, FaUsers, FaProjectDiagram, FaClipboardCheck, FaWarehouse,
  FaTools, FaFileInvoiceDollar, FaFileAlt, FaExclamationTriangle, FaGraduationCap,
  FaChalkboardTeacher, FaCalendarAlt, FaAngleRight, FaAngleDown, FaTachometerAlt, FaSignOutAlt,
  FaTasks, FaMapMarkedAlt, FaUserLock
} from 'react-icons/fa';
import { CiBank } from "react-icons/ci";
import { RiListIndefinite } from "react-icons/ri";
import { FaHouse } from "react-icons/fa6";
import { IoMdPerson } from "react-icons/io";
import { BiMath } from "react-icons/bi";
import logo from '../assets/logo.png';
import '../style/SideBar.css';
import { auth } from '../config/firebaseConfig';
import { signOut } from 'firebase/auth';

export const menuItems = [
  {
    icon: <FaTachometerAlt className="menu-icon" />,
    title: "Ana Sayfa",
    path: "/dashboard",
    submenu: [
      { title: "Yapılacaklar Listesi", path: "/todo-list", icon: <FaTasks className="submenu-icon" /> }
    ],
    requiredAuth: ["admin", "Kısıtlı Admin", "İnsan Kaynakları", "Proje Yöneticisi", "Finans Yöneticisi", "Saha Koordinatörü", "SMO Lead", "employee"]
  },
  {
    icon: <IoMdPerson className="menu-icon" />,
    title: "Profil",
    path: "/profile",
    submenu: [],
    requiredAuth: [] // Tüm kullanıcılar erişebilir
  },
  {
    icon: <FaUsers className="menu-icon" />,
    title: "Çalışan Menü",
    path: "/calisan",
    submenu: [
      { title: "Çalışan Yönetimi", path: "/employee-management", icon: <FaUsers className="submenu-icon" /> },
      { title: "Sigortalar", path: "/employee-insurance", icon: <FaShieldAlt className="submenu-icon" /> },
      { title: "İzin Yönetimi", path: "/izin-yonetimi", icon: <FaCalendarAlt className="submenu-icon" /> },
      { title: "Çalışan Hata Geribildirimleri", path: "/error-reports", icon: <FaExclamationTriangle className="submenu-icon" /> },
      { title: "Sayfa Yetkileri", path: "/sayfa-yetkileri", icon: <FaUserLock className="submenu-icon" />, requiredAuth: ["admin", "Kısıtlı Admin"] },

    ],
    requiredAuth: ["admin", "Kısıtlı Admin", "İnsan Kaynakları", "Proje Yöneticisi", "Finans Yöneticisi"]
  },
  {
    icon: <FaUserTag className="menu-icon" />,
    title: "Müşteri Menü",
    path: "/musteri",
    submenu: [
      { title: "Müşteri Yönetimi", path: "/customer-management", icon: <FaUsers className="submenu-icon" /> },
    ],
    requiredAuth: ["admin", "Kısıtlı Admin", "Proje Yöneticisi", "Finans Yöneticisi"]
  },
  {
    icon: <FaProjectDiagram className="menu-icon" />,
    title: "Proje Menü",
    path: "/proje",
    submenu: [
      { title: "Proje Yönetimi", path: "/projects-management", icon: <FaProjectDiagram className="submenu-icon" /> }
    ],
    requiredAuth: ["admin", "Kısıtlı Admin", "Proje Yöneticisi", "Finans Yöneticisi"]
  },
  {
    icon: <FaHandshake className="menu-icon" />,
    title: "Tarife / Alt Yüklenici Menü",
    path: "/sponsor",
    submenu: [
      { title: "Alt Yüklenici / Tarife Yönetimi", path: "/sponsor-management", icon: <FaHandshake className="submenu-icon" /> }
    ],
    requiredAuth: ["admin", "Finans Yöneticisi"]
  },
  {
    icon: <FaClipboardCheck className="menu-icon" />,
    title: "Operasyon Menü",
    path: "/operasyon",
    submenu: [
      { title: "Operasyon Yönetimi", path: "/operation-management", icon: <FaClipboardCheck className="submenu-icon" /> }
    ],
    requiredAuth: ["admin", "Kısıtlı Admin", "SMO Lead", "Finans Yöneticisi", "Proje Yöneticisi"]
  },
  {
    icon: <FaWarehouse className="menu-icon" />,
    title: "Stok Menü",
    path: "/stok",
    submenu: [
      { title: "Stok Yönetimi", path: "/stock-management", icon: <FaWarehouse className="submenu-icon" /> }
    ],
    requiredAuth: ["admin", "Kısıtlı Admin", "Proje Yöneticisi", "Finans Yöneticisi"]
  },
  {
    icon: <FaClipboardCheck className="menu-icon" />,
    title: "Kalite Menü",
    path: "/kalite",
    submenu: [
      { title: "Kalite Yönetimi", path: "/quality-management", icon: <FaClipboardCheck className="submenu-icon" /> }
    ],
    requiredAuth: ["admin", "Kısıtlı Admin", "Proje Yöneticisi", "Finans Yöneticisi"]
  },
  {
    icon: <FaGraduationCap className="menu-icon" />,
    title: "Eğitim Modülü",
    path: "/egitim",
    submenu: [
      { title: "Eğitim Yönetimi", path: "/education-management", icon: <FaChalkboardTeacher className="submenu-icon" /> },
      { title: "Eğitim Takvimi", path: "/training-calendar", icon: <FaCalendarAlt className="submenu-icon" /> },
      { title: "Eğitim Raporları", path: "/education-reports", icon: <FaFileAlt className="submenu-icon" /> }
    ],
    requiredAuth: ["admin", "Kısıtlı Admin", "Saha Koordinatörü", "Finans Yöneticisi"]
  },
  // {
  //   icon: <FaTools className="menu-icon" />,
  //   title: "TMS Menü",
  //   path: "/tms",
  //   submenu: [
  //     { title: "TMS Yönetimi", path: "/tms-yonetimi", icon: <FaTools className="submenu-icon" /> }
  //   ],
  //   requiredAuth: ["admin", "Finans Yöneticisi"]
  // },
  {
    icon: <FaFileInvoiceDollar className="menu-icon" />,
    title: "Finans Menü",
    path: "/finans",
    submenu: [
      { title: "Genel Finans Yönetimi", path: "/budget-management", icon: <FaChartLine className="submenu-icon" /> },
      { title: "Kredi & Sigorta Yönetimi", path: "/kredi-sigorta-yonetimi", icon: <FaShieldAlt className="submenu-icon" /> },
      { title: "Genel Bütçe Yönetimi", path: "/genel-butce-yonetimi", icon: <FaRegMoneyBillAlt className="submenu-icon" /> },
      { title: "Banka Hesap Tanımlama", path: "/bank-account-management", icon: <CiBank className="submenu-icon" /> },
      { title: "Maaş Ödemeleri", path: "/salary-payment", icon: <FaRegMoneyBillAlt className="submenu-icon" /> },
      { title: "Proje Finans Yönetimi", path: "/project-finance-management", icon: <FaRegMoneyBillAlt className="submenu-icon" /> },
      { title: "Çalışan Finans Yönetimi", path: "/employee-finance-management", icon: <FaRegMoneyBillAlt className="submenu-icon" /> },
      { title: "Saha Masrafları", path: "/saha-masraflari", icon: <FaReceipt className="submenu-icon" /> }
    ],
    requiredAuth: ["admin", "Finans Yöneticisi"]
  },
  {
    icon: <FaFileAlt className="menu-icon" />,
    title: "Raporlar",
    path: "/raporlar",
    submenu: [
      // { title: "Hata Raporları", path: "/error-reports", icon: <FaExclamationTriangle className="submenu-icon" /> },
      { title: "SMO Lead Raporları", path: "/smo-lead-reports", icon: <FaUsers className="submenu-icon" /> },
      { title: "Bölge Müdürleri Raporları", path: "/bolge-muduru-reports", icon: <FaMapMarkedAlt className="submenu-icon" /> },
      { title: "Çalışan Raporları", path: "/employee-reports", icon: <FaFileAlt className="submenu-icon" /> },
      { title: "Çalışan Analizi", path: "/employee-analysis", icon: <FaUsers className="submenu-icon" /> }
    ],
    requiredAuth: ["admin", "Kısıtlı Admin", "Finans Yöneticisi", "SMO Lead"]
  },
  {
    icon: <RiListIndefinite className="menu-icon" />,
    title: "Tanımlamalar",
    path: "/tanimlamalar",
    submenu: [
      { title: "Merkez Yönetimi", path: "/center-management", icon: <FaHouse className="submenu-icon" /> },
      { title: "Harici Personel Yönetimi", path: "/external-personnel-management", icon: <IoMdPerson className="submenu-icon" /> },
      { title: "Veri Girişi Değerleri", path: "/data-entry-values", icon: <BiMath className="submenu-icon" /> },
    ],
    requiredAuth: ["admin", "Kısıtlı Admin", "Proje Yöneticisi", "Finans Yöneticisi"]
  }
];

// Special email-based access for specific menu sections
export const SPECIAL_EMAIL_ACCESS = {
  'nagihan.cicisarac@habcarecro.com': ['/kalite', '/quality-management', '/egitim', '/education-management', '/training-calendar', '/education-reports', '/raporlar', '/smo-lead-reports'],
  'hulya.bayraktar@habcarecro.com': ['/kalite', '/quality-management', '/egitim', '/education-management', '/training-calendar', '/education-reports'],
  'arzu.dereli@habcarecro.com': ['/raporlar', '/smo-lead-reports'],
  'belgin.sari@habcarecro.com': ['/raporlar', '/smo-lead-reports'],
  'kubragizemcuralazakoglu@habcarecro.com': ['/raporlar', '/smo-lead-reports'],
  'derya.tokyurek@habcarecro.com': ['/raporlar', '/smo-lead-reports'],
  'gul.yazan@habcarecro.com': ['/raporlar', '/smo-lead-reports'],
  'nisaselin.aydin@habcarecro.com': ['/raporlar', '/smo-lead-reports'],
  'rumeysa.ilhan@habcarecro.com': ['/raporlar', '/smo-lead-reports'],
  'sevgi.tuncay@habcarecro.com': ['/raporlar', '/smo-lead-reports'],
  'fatmanur.guler@habcarecro.com': ['/raporlar', '/smo-lead-reports'],
  'unzile.yetkin@habcarecro.com': ['/raporlar', '/smo-lead-reports']
};

const SideBar = ({ active, onCollapse }) => {
  const [expandedMenus, setExpandedMenus] = useState({});
  const [isCollapsed, setIsCollapsed] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();
  const { userAuthorization, employeeData, isRegionManager, isCenterSmoBackup, pageAccess } = useUserProfile();
  const { pendingLeaveCount } = usePendingLeaves();
  const sidebarRef = useRef(null);

  // Bir menünün altında bekleyen izin bildirimi olup olmadığını kontrol et
  const menuHasPendingLeaves = (item) =>
    pendingLeaveCount > 0 && item.submenu?.some(sub => sub.path === '/izin-yonetimi');
  const userEmail = employeeData?.eMail?.toLowerCase() || '';

  // Check if current route is active or its parent is active
  const isActiveRoute = (path, submenu = []) => {
    const currentPath = location.pathname;
    
    if (currentPath === path) return true;
    
    // Check if any submenu path matches current path
    return submenu.some(item => item.path === currentPath);
  };

  // Pure role check (no path overrides). Empty/undefined means "everyone".
  const hasRole = useCallback((requiredAuth) => {
    if (!requiredAuth || requiredAuth.length === 0) return true;
    return requiredAuth.some(auth => userAuthorization.includes(auth));
  }, [userAuthorization]);

  // Precise per-path grant: hardcoded email allow-list OR admin-managed DB
  // pageAccess. Used to grant access to a specific page beyond the user's role.
  const hasPathGrant = useCallback((path) => {
    const specialPaths = SPECIAL_EMAIL_ACCESS[userEmail];
    if (specialPaths && specialPaths.includes(path)) return true;
    if (Array.isArray(pageAccess) && pageAccess.includes(path)) return true;
    return false;
  }, [userEmail, pageAccess]);

  // Combined check used for top-level menu items: role OR explicit path grant.
  const hasRequiredAuth = useCallback((requiredAuth, path) => {
    if (hasPathGrant(path)) return true;
    return hasRole(requiredAuth);
  }, [hasPathGrant, hasRole]);

  // "Bölge Müdürleri Raporları" is restricted to admins and employees who are
  // actually assigned as bölge müdürü to a region (dynamic, not a static role).
  const isAdmin = userAuthorization.includes('admin') || userAuthorization.includes('Kısıtlı Admin');

  // Pre-compute which menu items the user can see (avoids re-checking on every render)
  const visibleMenuItems = useMemo(() => {
    return menuItems.map(item => {
      const parentAllowed = hasRequiredAuth(item.requiredAuth, item.path);

      const visibleSubmenu = item.submenu.filter(sub => {
        // Precise grant for this exact page (email allow-list or DB pageAccess).
        const granted = hasPathGrant(sub.path);
        // Region reports: admins, assigned region managers, or an explicit grant.
        if (sub.path === '/bolge-muduru-reports') {
          return isAdmin || isRegionManager || granted;
        }
        // Role inheritance: a submenu is visible if the user's role satisfies
        // the submenu's own requiredAuth (or, when it has none, the parent's).
        const roleOk = hasRole(sub.requiredAuth || item.requiredAuth);
        // SMO Lead reports: also visible to a center's backup (Yedek SMO).
        if (sub.path === '/smo-lead-reports') {
          return granted || roleOk || isCenterSmoBackup;
        }
        return granted || roleOk;
      });

      // Show the parent if the user can access it normally, or if it has at
      // least one visible submenu item (e.g. a user granted only one report).
      const itemVisible = parentAllowed || visibleSubmenu.length > 0;
      return itemVisible ? { ...item, visibleSubmenu } : null;
    }).filter(Boolean);
  }, [hasRequiredAuth, hasPathGrant, hasRole, isAdmin, isRegionManager, isCenterSmoBackup]);

  const toggleMenu = (menu) => {
    setExpandedMenus(prev => {
      // Create a new object with all menus closed
      const newState = Object.keys(prev).reduce((acc, key) => {
        acc[key] = false;
        return acc;
      }, {});
      
      // Toggle the clicked menu
      newState[menu] = !prev[menu];
      
      return newState;
    });
  };

  // When route changes, expand the menu containing the active route
  useEffect(() => {
    menuItems.forEach(item => {
      if (item.submenu && item.submenu.some(subItem => subItem.path === location.pathname)) {
        setExpandedMenus(prev => ({ ...prev, [item.title]: true }));
      }
    });
  }, [location.pathname]);

  // Close click outside handler
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (sidebarRef.current && 
          !sidebarRef.current.contains(event.target) && 
          window.innerWidth <= 768) {
        // Handle close for mobile
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  const toggleCollapse = () => {
    const newCollapsedState = !isCollapsed;
    setIsCollapsed(newCollapsedState);

    // Notify parent component of collapse state change
    if (onCollapse) {
      onCollapse(newCollapsedState);
    }
  };

  const handleSignOut = async () => {
    try {
      await signOut(auth);
      navigate('/login');
    } catch (error) {
      console.error('Error signing out:', error);
    }
  };

  return (
    <aside 
      ref={sidebarRef}
      className={`sidebar ${active ? 'active' : ''} ${isCollapsed ? 'collapsed' : ''}`}
    >
      <div className="sidebar-header">
        {!isCollapsed && (
          <div className="sidebar-logo">
            <img src={logo} alt="HCC HABCARE CRO Logo" />
          </div>
        )}
        <button className="collapse-toggle" onClick={toggleCollapse}>
          <FaAngleRight className={`collapse-icon ${isCollapsed ? 'rotate' : ''}`} />
        </button>
      </div>

      <div className="sidebar-menu">
        {visibleMenuItems.map((item, index) => (
            <div
              key={index}
              className={`menu-item-container ${isActiveRoute(item.path, item.submenu) ? 'active' : ''}`}
            >
              {/* Main menu item */}
              {item.submenu.length > 0 ? (
                <div
                  className={`menu-item ${isActiveRoute(item.path, item.submenu) ? 'active' : ''}`}
                  onClick={() => item.path === '/dashboard' ? navigate(item.path) : toggleMenu(item.title)}
                >
                  <div className="menu-item-content">
                    <span className="menu-icon">
                      {item.icon}
                      {menuHasPendingLeaves(item) && (isCollapsed || !expandedMenus[item.title]) && (
                        <span className="sidebar-leave-dot" title={`${pendingLeaveCount} bekleyen izin talebi`} />
                      )}
                    </span>
                    {!isCollapsed && (
                      <>
                        <span className="menu-title">{item.title}</span>
                        <span className="expand-icon" onClick={(e) => { e.stopPropagation(); toggleMenu(item.title); }}>
                          {expandedMenus[item.title] ?
                            <FaAngleDown /> :
                            <FaAngleRight />
                          }
                        </span>
                      </>
                    )}
                  </div>
                </div>
              ) : (
                <Link
                  to={item.path}
                  className={`menu-item ${isActiveRoute(item.path, item.submenu) ? 'active' : ''}`}
                >
                  <div className="menu-item-content">
                    <span className="menu-icon">{item.icon}</span>
                    {!isCollapsed && (
                      <span className="menu-title">{item.title}</span>
                    )}
                  </div>
                </Link>
              )}

              {/* Submenu items */}
              {!isCollapsed && item.visibleSubmenu.length > 0 && (
                <div
                  className={`submenu ${expandedMenus[item.title] ? 'expanded' : ''}`}
                >
                  {item.visibleSubmenu.map((subItem, subIndex) => (
                      <Link
                        key={subIndex}
                        to={subItem.path}
                        className={`submenu-item ${location.pathname === subItem.path ? 'active' : ''}`}
                      >
                        <span className="submenu-icon">{subItem.icon}</span>
                        <span className="submenu-title">{subItem.title}</span>
                        {subItem.path === '/izin-yonetimi' && pendingLeaveCount > 0 && (
                          <span className="sidebar-leave-badge" title={`${pendingLeaveCount} bekleyen izin talebi`}>
                            {pendingLeaveCount > 99 ? '99+' : pendingLeaveCount}
                          </span>
                        )}
                      </Link>
                  ))}
                </div>
              )}
            </div>
        ))}
      </div>

      <div className="sidebar-footer">
        <button className="sign-out-button" onClick={handleSignOut}>
          <FaSignOutAlt className="sign-out-icon" />
          {!isCollapsed && <span>Çıkış Yap</span>}
        </button>
      </div>
    </aside>
  );
};

export default SideBar;
